/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LifeCycleStage } from './LifeCycleStage';
import {
	LifeCycleStageFromJSON,
	LifeCycleStageFromJSONTyped,
	LifeCycleStageToJSON,
} from './LifeCycleStage';
import type { PolicyEvaluation } from './PolicyEvaluation';
import {
	PolicyEvaluationFromJSON,
	PolicyEvaluationFromJSONTyped,
	PolicyEvaluationToJSON,
} from './PolicyEvaluation';
import type { ServiceTeamMemberWithDetails } from './ServiceTeamMemberWithDetails';
import {
	ServiceTeamMemberWithDetailsFromJSON,
	ServiceTeamMemberWithDetailsFromJSONTyped,
	ServiceTeamMemberWithDetailsToJSON,
} from './ServiceTeamMemberWithDetails';

/**
 * A service team within the organization
 * @export
 * @interface ServiceTeamWithDetails
 */
export interface ServiceTeamWithDetails {
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ServiceTeamWithDetails
	 */
	rID: string;
	/**
	 *
	 * @type {Date}
	 * @memberof ServiceTeamWithDetails
	 */
	createdAtUtc: Date;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ServiceTeamWithDetails
	 */
	createdByUserRID: string;
	/**
	 *
	 * @type {Date}
	 * @memberof ServiceTeamWithDetails
	 */
	lastUpdatedAtUtc?: Date | null;
	/**
	 * A URI value that typically starts with the "sharefile" schema.  Segments are delimited with a "/". Segments are composed of a leaf  type and identifier that is delimited by "-".
	 *
	 * @type {string}
	 * @memberof ServiceTeamWithDetails
	 */
	lastUpdatedByUserRID?: string;
	/**
	 * The name of the service team
	 * @type {string}
	 * @memberof ServiceTeamWithDetails
	 */
	name: string;
	/**
	 * The description of the service team
	 * @type {string}
	 * @memberof ServiceTeamWithDetails
	 */
	description?: string;
	/**
	 *
	 * @type {LifeCycleStage}
	 * @memberof ServiceTeamWithDetails
	 */
	stage?: LifeCycleStage;
	/**
	 *
	 * @type {Array<ServiceTeamMemberWithDetails>}
	 * @memberof ServiceTeamWithDetails
	 */
	members?: Array<ServiceTeamMemberWithDetails> | null;
	/**
	 * The number of clients assigned to this service team
	 * @type {number}
	 * @memberof ServiceTeamWithDetails
	 */
	assignmentCount?: number | null;
	/**
	 *
	 * @type {{ [key: string]: PolicyEvaluation; }}
	 * @memberof ServiceTeamWithDetails
	 */
	actions?: { [key: string]: PolicyEvaluation };
}

/**
 * Check if a given object implements the ServiceTeamWithDetails interface.
 */
export function instanceOfServiceTeamWithDetails(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;
	isInstance = isInstance && 'createdAtUtc' in value;
	isInstance = isInstance && 'createdByUserRID' in value;
	isInstance = isInstance && 'name' in value;

	return isInstance;
}

export function ServiceTeamWithDetailsFromJSON(json: any): ServiceTeamWithDetails {
	return ServiceTeamWithDetailsFromJSONTyped(json, false);
}

export function ServiceTeamWithDetailsFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ServiceTeamWithDetails {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
		createdAtUtc: new Date(json['createdAtUtc']),
		createdByUserRID: json['createdByUserRID'],
		lastUpdatedAtUtc: !exists(json, 'lastUpdatedAtUtc')
			? undefined
			: json['lastUpdatedAtUtc'] === null
			? null
			: new Date(json['lastUpdatedAtUtc']),
		lastUpdatedByUserRID: !exists(json, 'lastUpdatedByUserRID')
			? undefined
			: json['lastUpdatedByUserRID'],
		name: json['name'],
		description: !exists(json, 'description') ? undefined : json['description'],
		stage: !exists(json, 'stage') ? undefined : LifeCycleStageFromJSON(json['stage']),
		members: !exists(json, 'members')
			? undefined
			: json['members'] === null
			? null
			: (json['members'] as Array<any>).map(ServiceTeamMemberWithDetailsFromJSON),
		assignmentCount: !exists(json, 'assignmentCount')
			? undefined
			: json['assignmentCount'],
		actions: !exists(json, 'actions')
			? undefined
			: mapValues(json['actions'], PolicyEvaluationFromJSON),
	};
}

export function ServiceTeamWithDetailsToJSON(value?: ServiceTeamWithDetails | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
		createdAtUtc: value.createdAtUtc.toISOString(),
		createdByUserRID: value.createdByUserRID,
		lastUpdatedAtUtc:
			value.lastUpdatedAtUtc === undefined
				? undefined
				: value.lastUpdatedAtUtc === null
				? null
				: value.lastUpdatedAtUtc.toISOString(),
		lastUpdatedByUserRID: value.lastUpdatedByUserRID,
		name: value.name,
		description: value.description,
		stage: LifeCycleStageToJSON(value.stage),
		members:
			value.members === undefined
				? undefined
				: value.members === null
				? null
				: (value.members as Array<any>).map(ServiceTeamMemberWithDetailsToJSON),
		assignmentCount: value.assignmentCount,
		actions:
			value.actions === undefined
				? undefined
				: mapValues(value.actions, PolicyEvaluationToJSON),
	};
}
